import React, {
  useEffect, useState,
} from 'react';
import {
  useObserver,
} from 'mobx-react';
import {
  useParams,
} from 'react-router';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import GeneralViewModal from '../../components/modals/generalViewModal';
import {
  DeglawyPointsTransaction,
  WifiPackageFawryTransaction,
  WifiPackageOrangeTransaction,
  WifiPackageSubscriptionTransaction,
} from '../../mobx-store/storeInterfaces/wifiPackageInterface';
import {
  RequestStatus, stores,
} from '../../mobx-store';
import {
  translate,
} from '../../helperFunctions/translation';

const WifiPackagesUserSubscribeDetails: React.FC = () => {
  const {
    wifiPackagesStore,
  } = stores;
  const {
    userWifiPackageDetails,
  } = wifiPackagesStore;

  const {
    userId,
  } = useParams<{userId: string}>();

  const [fawryOrder, setFawryOrder] = useState<number>(-1);
  const [OrangeOrder, setOrangeOrder] = useState<number>(-1);
  const [selectedOrder, setSelectedOrder] = useState<number>(-1);
  const [deglawyPointOrder, setDeglawyPointOrder] = useState<number>(-1);

  useEffect(() => {
    wifiPackagesStore.getUserWifiPackageDetails(+userId);
  }, [userId]);

  const StateModel = (props: { 
    state: RequestStatus, title: string,
    content: JSX.Element, open: boolean, handleClose: () => void
  }) => {
    if (props.state === RequestStatus.SUCCESS) {
      return (
        <GeneralViewModal
          title={props.title}
          content={props.content}
          open={props.open}
          handleClose={props.handleClose}
        />
      );
    }
    return (<> </>);
  };

  const FawryTable = (props: {
    state: RequestStatus, fawryTransactions: WifiPackageFawryTransaction []
  }) => (
    <GeneralTableComponent
      emptyMessage={translate('settingsListNoSettingsMessage')}
      title=""
      tableHeader={[
        {
          title: 'Fawry Order Id',
        },
        {
          title: 'status',
        },
        {
          title: 'amount',
        },
      ]}
      tableData={
          props.fawryTransactions || []
      }
      tableCellTypes={[
        {
          key: 'fawryOrderId',
          cellType: 'Text',
        },
        {
          key: 'status',
          cellType: 'Text',
        },
        {
          key: 'amount',
          cellType: 'Text',
        },
      ]}
      loadingStatus={[
        wifiPackagesStore.state,
      ]}
    />
  );

  const DeglawyPointsTable = (props: {
    deglawyPointsTransactions: DeglawyPointsTransaction []
  }) => (
    <GeneralTableComponent
      emptyMessage={translate('settingsListNoSettingsMessage')}
      title=""
      tableHeader={[
        {
          title: 'id',
        },
        {
          title: 'amount',
        },
        {
          title: 'pointsPerMoneyUnit',
        },
        {
          title: 'points',
        },
        {
          title: 'dsquaresTransactionId',
        }
      ]}
      tableData={
          props.deglawyPointsTransactions || []
      }
      tableCellTypes={[
        {
          key: 'id',
          cellType: 'Text',
        },
        {
          key: 'amount',
          cellType: 'Text',
        },
        {
          key: 'pointsPerMoneyUnit',
          cellType: 'Text',
        },
        {
          key: 'points',
          cellType: 'Text',
        },
        {
          key: 'dsquaresTransactionId',
          cellType: 'Text',
        },
      ]}
      loadingStatus={[
        wifiPackagesStore.state,
      ]}
    />
  );

  const OrangeTable = (props: {
    state: RequestStatus, orangeTransactions: WifiPackageOrangeTransaction []
  }) => (
    <GeneralTableComponent
      emptyMessage={translate('settingsListNoSettingsMessage')}
      title=""
      tableHeader={[
        {
          title: 'status',
        },
        {
          title: 'price',
        },
        {
          title: 'last try date',
        }
      ]}
      tableData={
          props.orangeTransactions || []
      }
      tableCellTypes={[
        {
          key: 'status',
          cellType: 'Text',
        },
        {
          key: 'price',
          cellType: 'Text',
        },
        {
          key: 'lastTryDate',
          cellType: 'Text',
        }
      ]}
      loadingStatus={[
        wifiPackagesStore.state,
      ]}
    />
  );

  const TransactionsTable = (props: {
    state: RequestStatus, transactions: WifiPackageSubscriptionTransaction []
  }) => (
    <GeneralTableComponent
      emptyMessage={translate('settingsListNoSettingsMessage')}
      title=""
      tableHeader={[
        {
          title: 'Transaction Id',
        },
        {
          title: 'amount',
        },
        {
          title: 'status',
        },
        {
          title: 'Payment date',
        },
        {
          title: 'Orange Transactions',
        },
        {
          title: 'Fawry Transactions',
        },
        {
          title: translate('deglawyPoints'),
        },
      ]}
      tableData={
        props.transactions.map((t) => ({
          ...t,
          orangeTransactionLog: translate('details'),
          fawryTransactions: translate('details'),
          deglawyPointsTransactions: translate('details'),
        }))
      }
      tableCellTypes={[
        {
          key: 'transactionId',
          cellType: 'Text',
        },
        {
          key: 'amount',
          cellType: 'Text',
        },
        {
          key: 'status',
          cellType: 'Text',
        },
        {
          key: 'paymentDate',
          cellType: 'Text',
        },
        {
          key: 'orangeTransactionLog',
          cellType: 'Button',
          onClick: (index) => setOrangeOrder(index),
          disabled: (index: number) => !userWifiPackageDetails[selectedOrder]
            ?.transactions[index].orangeTransactionLog.length,
        },
        {
          key: 'fawryTransactions',
          cellType: 'Button',
          onClick: (index) => setFawryOrder(index),
          disabled: (index: number) => !userWifiPackageDetails[selectedOrder]
            ?.transactions[index].fawryTransactions.length,
        },
        {
          key: 'deglawyPointsTransactions',
          cellType: 'Button',
          onClick: (index) => setDeglawyPointOrder(index),
          disabled: (index: number) => !userWifiPackageDetails[selectedOrder]
            ?.transactions[index].deglawyPointsTransactions.length,
        },
      ]}
      loadingStatus={[
        wifiPackagesStore.state,
      ]}
    />
  );

  const WifiSubscriptionsTable = (props: {state: RequestStatus}) => (
    <GeneralTableComponent
      emptyMessage={translate('settingsListNoSettingsMessage')}
      title={translate('wifiSubscriptions')}
      tableHeader={[
        {
          title: 'Order Id',
        },
        {
          title: 'Wifi Package Name',
        },
        {
          title: 'Status',
        },
        {
          title: 'Phone number',
        },
        {
          title: 'Subscription type (for self?)',
        },
        {
          title: 'transactions',
        },
      ]}
      tableData={
        wifiPackagesStore.userWifiPackageDetails.map((uwpd) => {
          const FIRST_TRANSACTION_INDEX = 0;
          const packageDetailsRow = {
            ...uwpd,
            status: uwpd.transactions && uwpd.transactions.length
              ? uwpd.transactions[FIRST_TRANSACTION_INDEX]?.status : translate('unknownStatus'),
            subscribeForSelf: uwpd.subscribeForSelf ? 'yes' : 'no',
            transactions: translate('details'),
          };
          return packageDetailsRow;
        })
      }
      tableCellTypes={[
        {
          key: 'orderId',
          cellType: 'Text',
        },
        {
          key: 'wifiPackageName',
          cellType: 'Text',
        },
        {
          key: 'status',
          cellType: 'Text',
        },
        {
          key: 'orderPhoneNumber',
          cellType: 'Text',
        },
        {
          key: 'subscribeForSelf',
          cellType: 'Text',
        },
        {
          key: 'transactions',
          cellType: 'Button',
          onClick: (index) => setSelectedOrder(index),
        },
      ]}
      loadingStatus={[
        wifiPackagesStore.state,
      ]}
    />
  );

  return useObserver(() => (
    <div>
      <WifiSubscriptionsTable state={wifiPackagesStore.state} />
      <StateModel
        state={wifiPackagesStore.state}
        title={translate('transactions')}
        content={(
          <TransactionsTable
            state={wifiPackagesStore.state}
            transactions={wifiPackagesStore?.userWifiPackageDetails[selectedOrder]?.transactions}
          />
        )}
        open={selectedOrder > -1}
        handleClose={() => setSelectedOrder(-1)}
      />
      <StateModel
        state={wifiPackagesStore.state}
        title={translate('orangeLogs')}
        content={(
          <OrangeTable
            state={wifiPackagesStore.state}
            orangeTransactions={wifiPackagesStore?.userWifiPackageDetails[selectedOrder]?.transactions[OrangeOrder]?.orangeTransactionLog}
          />
        )}
        open={OrangeOrder > -1}
        handleClose={() => setOrangeOrder(-1)}
      />

      <StateModel
        state={wifiPackagesStore.state}
        title={translate("fawryLogs")}
        content={(
          <FawryTable
            state={wifiPackagesStore.state}
            fawryTransactions={wifiPackagesStore?.userWifiPackageDetails[selectedOrder]?.transactions[fawryOrder]?.fawryTransactions}
          />
        )}
        open={fawryOrder > -1}
        handleClose={() => setFawryOrder(-1)}
      />

      <StateModel
        state={wifiPackagesStore.state}
        title={translate('deglawyPoints')}
        content={(
          <>
            <DeglawyPointsTable
              deglawyPointsTransactions={
                userWifiPackageDetails[selectedOrder]?.transactions[deglawyPointOrder]?.deglawyPointsTransactions
              }
            />
          </>
        )}
        open={deglawyPointOrder > -1}
        handleClose={() => setDeglawyPointOrder(-1)}
      />
    </div>
  ));
};

export default WifiPackagesUserSubscribeDetails;
